import type { DOMAttributes } from "react";
import { useState } from "react";
import { cx } from "class-variance-authority";
import { ReactComponent as UploadIcon } from "./assets/upload.svg";

import * as styles from "./Upload.module.scss";

type UploadBoxProps = {
  id?: string;
  className?: string;
  onSelect: (file: File) => void;
  accept?: string;
  title?: string;
  subtitle?: string;
};

const UploadBox = ({
  id = "upload",
  className,
  onSelect,
  accept,
  title,
  subtitle,
}: UploadBoxProps) => {
  const [isDropping, setIsDropping] = useState(false);

  const dragOverHandler: DOMAttributes<HTMLDivElement>["onDragOver"] = (
    event,
  ) => {
    event.preventDefault();
    setIsDropping(true);
  };

  const dragLeaveHandler: DOMAttributes<HTMLDivElement>["onDragLeave"] = (
    event,
  ) => {
    event.preventDefault();
    setIsDropping(false);
  };

  const dropHandler: DOMAttributes<HTMLDivElement>["onDrop"] = () => {
    setIsDropping(false);
  };

  return (
    <div
      onDragOver={dragOverHandler}
      onDragLeave={dragLeaveHandler}
      onDrop={dropHandler}
      className={cx(
        styles.uploadBox,
        { [styles.dropping]: isDropping },
        className,
      )}
    >
      <div className={styles.icon}>
        <UploadIcon />
      </div>
      <div className={styles.title}>
        {title || "Drag & drop file to upload or"}
      </div>
      <label className={styles.label} htmlFor={id}>
        {subtitle || "Browse Files"}
      </label>
      <input
        id={id}
        type="file"
        className={styles.input}
        accept={accept}
        onChange={({ target }) => {
          if (target.files?.length) {
            onSelect(target.files[0]);
          }
        }}
      />
    </div>
  );
};

export { UploadBox };
